import { useEffect } from 'react';

import { InputText, InputTextProps } from 'ui/inputs';
import { FormField } from 'ui/formField';
import { getNewDate } from 'utils/date';

export type TemplateNameInputProps = {
  /* content strings to render */
  content: unknown;
  /** a defaulted date string for the input */
  defaultDate?: string;
  /* current template name */
  templateName: string;
  /* Function to update template name state */
  setTemplateName: (name: string) => void;
  /* Error text to show inline with input when error state is enabled */
  errorText?: string;
  /* Help text to show inline with input when error state is not enabled */
  helpText?: string;
};

export const TemplateNameInput = ({
  templateName,
  setTemplateName,
  content,
  defaultDate = getNewDate().format('llll'),
  type = 'text',
  errorText = 'Please enter fewer than 255 characters',
  helpText,
  ...props
}: TemplateNameInputProps & Partial<InputTextProps>) => {
  const hasError = templateName.length > 255 || props.hasError;

  useEffect(() => {
    if (!templateName) {
      const defaultName = `Template created on ${defaultDate}`; // formats to this -> Mon, Jan 11, 2021 1:44 PM
      setTemplateName(defaultName);
    }
  }, []);

  return (
    <FormField
      errorText={errorText}
      hasError={hasError}
      isRequired={true}
      // @ts-ignore
      labelText={content.label}
      restrictionText={'255 characters'}
      helpText={!hasError && helpText}
    >
      <InputText
        data-test="template-name-input"
        id={'template-name-input'}
        onChange={setTemplateName}
        placeholder="Give your template a name"
        value={templateName}
        type={type}
        hasError={hasError}
        {...props}
      />
    </FormField>
  );
};
